import { useMutation, useQuery } from "@tanstack/react-query";
import { templateApiService } from "modules/Library/Template/api/template.api";
import Template from "../helper/template.types";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statusCode: number;
}

export const useTemplateApi = ({
  searchText,
  pageNumber = 1,
  pageSize = 10,

  templateid,
  selectAllEnabled = true,
}: {
  searchText?: string | null;
  pageNumber?: number;
  pageSize?: number;

  templateid?: number | null;
  selectAllEnabled?: boolean;
} = {}) => {
  const payload: Template = {
    searchtext: searchText,
    pagenumber: pageNumber,
    pagesize: pageSize,
    status: "A",
  };

  // SelectAll
  const SelectAllQuery = useQuery({
    queryKey: ["template-selectAll", searchText, pageNumber, pageSize],
    queryFn: () => templateApiService.getSelectAllData(payload),
    enabled: selectAllEnabled,
  });

  // Detail SelectAll
  const DetailSelectQuery = useQuery({
    queryKey: ["template-detail", templateid],
    queryFn: () =>
      templateApiService.getDetailSelectAllData({
        ...payload,
        templateid: templateid as number,
      }),
    enabled: !!templateid,
    refetchOnWindowFocus: false,
  });

  // Insert
  const InsertMutation = useMutation<ApiResponse, Error, Template>({
    mutationFn: (data: Template) => templateApiService.insertData(data),
  });

  // Update
  const UpdateMutation = useMutation<ApiResponse, Error, Template>({
    mutationFn: (data: Template) => templateApiService.updateData(data),
  });

  // Delete
  const DeleteMutation = useMutation<ApiResponse, Error, Template>({
    mutationFn: (data: Template) => templateApiService.deleteData(data),
  });

  return {
    SelectAllQuery,
    DetailSelectQuery,
    InsertMutation,
    UpdateMutation,
    DeleteMutation,
  };
};
